<template>
    <div :class="formClass" :tabindex="tabIndex">
        <div class="form__checkbox">
            <input
                type="checkbox"
                :id="id"
                :name="name"
                :value="formValue"
                v-model="inputValue"
                @change="onChange"
            >
            <label :for="id">
                <slot></slot>
            </label>
        </div>

        <div class="form__error" v-show="errorMessage">
            {{ errorMessage }}
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
    props: {
        'modelValue': {type: Boolean, default: false}, // current model value
        'formValue': {type: String, required: true}, // form value for checked state
        'name': {type: String, required: true}, // name of the input
        'tabIndex': {type: String, default: ''}, // tab index of the element

        // styling
        'small': {type: Boolean, default: false},
        'validationState': {type: Object},
    },
    emits: [
        'update:modelValue',
        'change',
    ],
    data() {
        return {
            id: '',
            inputValue: false,
        };
    },
    computed: {
        formClass(): VueClassMapping {
            return {
                'form__field': true,
                'form__field--checkbox': true,
                'form__field--small': !!this.small,
                'form__field--invalid': !!this.errorMessage,
            };
        },
        errorMessage(): string {
            if (this.validationState && this.validationState.$errors && this.validationState.$errors.length > 0) {
                return this.validationState.$errors[0].$message;
            }

            return '';
        },
    },
    methods: {
        onChange(e: Event) {
            this.$emit('update:modelValue', this.inputValue);
            this.$emit('change', this.inputValue);
        },
    },
    watch: {
        modelValue(newValue) {
            if (this.inputValue !== newValue) {
                this.inputValue = newValue;
            }
        },
    },

    mounted() {
        this.id = this.name + '_' + (Math.random() + 1).toString(36).substring(7);
        this.inputValue = this.modelValue;
    },
});
</script>
